// import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import EditableDatable from "./EditableDatatable";
import {
  bidLineswithoutcompany,
  token,
  companyDefault,
  uOMApi,
  vatGroupings,
  paymentTermsApi,
  countriesAPIs,
  rfpLineswithoutcompany,
  currenciesApi,
} from "../HelperFx/datalinks";
import useFetch from "../utils/UseFetch";
import axios from "axios";

const BidLines = ({ docNo, rfpNo, Status, refreshKey = 0 }) => {
  const [fdata, setData] = useState([]);

  const apiUrl = `${bidLineswithoutcompany}?${companyDefault}&$filter = documentNo eq '${docNo}'`;

  const rfpLinesApiUrl = `${rfpLineswithoutcompany}?${companyDefault}&$filter=docNo eq '${rfpNo}'`;

  const { data: fetchedData } = useFetch(apiUrl, token);

  const { data: UOMData } = useFetch(uOMApi, token);
  const { data: PTData } = useFetch(paymentTermsApi, token);
  const { data: CountriesData } = useFetch(countriesAPIs, token);
  const { data: vatGroupingsData } = useFetch(vatGroupings, token);
  const { data: CurrenciesData } = useFetch(currenciesApi, token);

  // Get data from the APIs
  const { data: RFPLines } = useFetch(rfpLinesApiUrl, token);
  // console.log(rfpLinesApiUrl);
  // const { data: fetchedData, loading, error } = useFetch(apiUrl, base64backendtoken);
  const fetchedDataItems = fetchedData?.value;
  const lvUOMData = UOMData?.value;
  const lvPTData = PTData?.value;
  const lvCurrenciesData = CurrenciesData?.value;

  const lvCountriesData = CountriesData?.value;
  const lvVatGroupingsData = vatGroupingsData?.value;
  const lvRFPLines = RFPLines?.value;

  // console.log("Here: ", lvRFPLines);
  // console.log(fetchedDataItems)
  // console.log(docNo);

  useEffect(() => {
    if (fetchedDataItems) {
      setData(fetchedDataItems);
    }
  }, [fetchedDataItems, refreshKey]);

  const handlePageBlur = async (id, field, value, updated) => {
    const row = updated.find((r) => r.systemId === id);

    if (!row) return;

    if (!row.systemId || row.systemId.trim() === "") {
      console.warn("Skipping save. systemId is empty for row:", row);
      return;
    }

    try {
      if (
        row.systemId?.startsWith("empty") &&
        (row.systemSerialId === null ||
          row.systemSerialId === undefined ||
          row.systemSerialId === "")
      ) {
        // 🔹 INSERT (new record)
        const insertPayload = {
          documentNo: docNo,
          type: "Item",
          rfpNo: rfpNo,
          no: row.no,
        };
        if (!insertPayload.no) {
          console.warn("Skipping insert. Required fields missing:", {
            no: insertPayload.no,
          });
          return; // exit early, don’t insert
        }
        console.log("Inserting new row:", insertPayload);
        const response = await axios.post(
          `${bidLineswithoutcompany}?${companyDefault}`,
          insertPayload,
          {
            headers: {
              Authorization: `Basic ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        console.log(response);

        // Set the new record data
        const newRow = await response.data;
        newRow.systemSerialId = newRow.systemId;
        newRow.systemId = id;
        updated = updated
          .filter((r) => r.systemId !== row.systemId)
          .concat({ ...newRow });

        setData(updated);
        // window.location.reload();
      } else {
        // 🔹 PATCH (update existing record with concurrency check)
        const patchPayload = {
          [field]: value, // only update the changed field
        };

        console.log("Patching row:", row.systemId, patchPayload);
        let ssid = "";

        if (row.systemSerialId) {
          ssid = row.systemSerialId;
        } else ssid = row.systemId;

        const response = await axios.patch(
          `${bidLineswithoutcompany}(${ssid})?${companyDefault}`,
          patchPayload,
          {
            headers: {
              Authorization: `Basic ${token}`,
              "Content-Type": "application/json",
              "If-Match": "*",
              // 👆 send etag if available, else allow overwrite with "*"
            },
          },
        );
        const bidLineDate = await response.data;
        bidLineDate.systemSerialId = bidLineDate.systemId;
        bidLineDate.systemId = id;
        // updated = updated.filter(r => r.systemId !== row.systemId).concat({ ...bidLineDate});

        updated = updated.map((r) =>
          r.systemId === row.systemId ? { ...bidLineDate } : r,
        );
        console.log(updated);

        setData(updated);

        // setData(updated);
      }
    } catch (error) {
      console.error("Error saving row:", error.response?.data || error.message);
    }
  };

  const colToUse = [
    {
      label: "No",
      type: "select",
      options:
        lvRFPLines?.map((prod) => ({
          value: prod.no,
          label: `${prod.no}`,
        })) || [],
      name: "no",
      sortable: true,
      width: "250px",
      disabled: Status !== "Open",
    },
    {
      label: "Description",
      type: "text",
      name: "description",
      sortable: true,
      width: "250px",
      disabled: true,
    },
    {
      label: "Product Lot",
      type: "text",
      name: "productLot",
      sortable: true,
      width: "150px",
      disabled: true,
    },
    {
      label: "Unit of Measure",
      type: "select",
      name: "uom",
      options:
        lvUOMData?.map((prod) => ({
          value: prod.Code,
          label: `${prod.Code}-${prod.Description}`,
        })) || [],
      sortable: true,
      tabIndex: 0,
      width: "150px",
      disabled: true,
      // disabled: Status !== "Open",
    },
    {
      label: "Supplier Currency",
      type: "select",
      name: "supplierCurrency",
      options:
        lvCurrenciesData?.map((cur) => ({
          value: cur.code,
          label: `${cur.code}-${cur.description}`,
        })) || [],
      sortable: true,
      width: "150px",
      disabled: Status !== "Open",
    },
    {
      label: "Quantity",
      type: "decimal",
      name: "quantity",
      sortable: true,
      width: "120px",
      disabled: true,
      // disabled: Status !== "Open",
    },
    {
      label: "Unit Cost",
      type: "decimal",
      name: "unitCost",
      sortable: true,
      width: "120px",
      disabled: Status !== "Open",
    },
    {
      label: "VAT Product Group",
      type: "select",
      name: "VatProdGr",
      options:
        lvVatGroupingsData?.map((prod) => ({
          value: prod.code,
          label: `${prod.code}-${prod.description}`,
        })) || [],
      sortable: true,
      width: "150px",
      disabled: Status !== "Open",
    },
    {
      label: "NDA Registration No (Applicable in Uganda)",
      type: "text",
      name: "ndaRegistrationNo",
      sortable: true,
      width: "180px",
      disabled: Status === "Sent",
    },
    {
      label: "Manufacturer",
      type: "text",
      name: "manufacturer",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Manufacturer Product Description",
      type: "text",
      name: "manufactureProductDescription",
      sortable: true,
      width: "250px",
      disabled: Status !== "Open",
    },
    {
      label: "Brand Name",
      type: "text",
      name: "brandName",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Country Of Origin",
      type: "select",
      name: "countryOfOrigin",
      options:
        lvCountriesData?.map((Coun) => ({
          value: Coun.code,
          label: `${Coun.code}-${Coun.Name}`,
        })) || [],
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Payment Terms",
      type: "select",
      name: "pmtTerms",
      options:
        lvPTData?.map((term) => ({
          value: term.code,
          label: `${term.code}-${term.description}`,
        })) || [],
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Prepayment Percentage",
      type: "decimal",
      name: "prepaymentPercentage",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Lead Time Ex Works (Days)",
      type: "decimal",
      name: "leadTimeXWorks",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Lead Time Fresh Product (Days)",
      type: "decimal",
      name: "leadTimeFreshProdinDays",
      sortable: true,
      width: "200px",
      disabled: Status !== "Open",
    },
    {
      label: "Total Shelf Life (D,W,M,Y 1D for 1 Day ....)",
      type: "text",
      name: "totalShelfLifeProd",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Qty Per Carton",
      type: "decimal",
      name: "qtyperCarton",
      sortable: true,
      width: "150px",
      disabled: Status !== "Open",
    },
    {
      label: "Carton Dimension",
      type: "text",
      name: "cartonDimension",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "No Of Pallets",
      type: "decimal",
      name: "noOfPallets",
      sortable: true,
      width: "150px",
      disabled: Status !== "Open",
    },
    {
      label: "No Of Containers",
      type: "decimal",
      name: "noOfContainers",
      sortable: true,
      width: "150px",
      disabled: Status !== "Open",
    },
    {
      label: "Weight Per Carton",
      type: "decimal",
      name: "weightPerCarton",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Volume Per Carton",
      type: "decimal",
      name: "volPerCarton",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Cartons Per Pallet",
      type: "decimal",
      name: "cartonsPerPallet",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "EX Unit Price",
      type: "decimal",
      name: "exUnitPrice",
      sortable: true,
      width: "150px",
      disabled: Status !== "Open",
    },
    {
      label: "DDP JMS Unit Price",
      type: "decimal",
      name: "ddpJmsUnitPrice",
      sortable: true,
      width: "180px",
      disabled: Status !== "Open",
    },
    {
      label: "Comment / Remark",
      type: "text",
      name: "comentOrRemark",
      sortable: true,
      width: "250px",
      disabled: Status !== "Open",
    },
    {
      label: "BUBU (Buy Uganda Build Uganda)",
      type: "text",
      name: "isBUBU",
      sortable: true,
      width: "120px",
      disabled: Status !== "Open",
    },
    {
      label: "Consignment",
      type: "text",
      name: "isCosignment",
      sortable: true,
      width: "120px",
      disabled: Status !== "Open",
    },
  ];

  return (
    <EditableDatable
      linesApi={bidLineswithoutcompany}
      initialData={fdata}
      columns={colToUse}
      pageOnBlur={handlePageBlur}
      converteddocType={51402120}
      ShowActions={Status === "Open"}
    />
  );
};

export default BidLines;
